import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import {
  MAX_DENSITY,
  type MetricsMode,
  MIN_DENSITY,
  TOGGLE_BUTTON_SX,
  TOOLBAR_ROW_SX,
} from './utils';

interface MetricsDensityToolbarProps {
  metricsMode: MetricsMode;
  onMetricsModeChange: (mode: MetricsMode) => void;
  density: number;
  onDensityChange: (density: number) => void;
}

/** The grid-only "Metrics/Density" row shared by every creatives grid — owned by the grid, not
 * the board, so it disappears in table view. */
export function MetricsDensityToolbar({
  metricsMode,
  onMetricsModeChange,
  density,
  onDensityChange,
}: MetricsDensityToolbarProps): ReactNode {
  return (
    <Box sx={TOOLBAR_ROW_SX}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="overline" color="text.secondary">
          Metrics
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={metricsMode}
          onChange={(_event, next: MetricsMode | null) => {
            if (next !== null) onMetricsModeChange(next);
          }}
          sx={{ backgroundColor: 'background.page' }}
        >
          <ToggleButton value="fixed" sx={TOGGLE_BUTTON_SX}>
            Fixed
          </ToggleButton>
          <ToggleButton value="hover" sx={TOGGLE_BUTTON_SX}>
            Hover
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="overline" color="text.secondary">
          Density
        </Typography>
        <Slider
          size="medium"
          value={density}
          min={MIN_DENSITY}
          max={MAX_DENSITY}
          onChange={(_event, next) => onDensityChange(next as number)}
          sx={{ width: 140 }}
        />
      </Box>
    </Box>
  );
}
